import type { OnDestroy } from '@angular/core';
import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject, Subject, ReplaySubject } from 'rxjs';
import { share, takeUntil } from 'rxjs/operators';
import { CookieService } from './cookie.service';

@Injectable({
  providedIn: 'root',
})
export class SocialEmbedsService implements OnDestroy {
  private consentStatusSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  private serviceDestroys$: Subject<void> = new Subject<void>();

  consentIsGiven: Observable<boolean> = this.consentStatusSubject.pipe(takeUntil(this.serviceDestroys$));

  constructor(private cookieService: CookieService) {}

  ngOnDestroy() {
    this.serviceDestroys$.next(undefined);
    this.serviceDestroys$.complete();
  }

  setConsentStatus(consentIsGiven: boolean) {
    this.setConsentAngularWide(consentIsGiven);
    this.cookieService.set('tt-social-consent', 'consentIsGiven', 60, '/');
  }

  setConsentAngularWide(consentIsGiven: boolean) {
    this.consentStatusSubject.next(consentIsGiven);
  }

  loadScript(scriptId: string, scriptSrc: string): Observable<any> {
    const onload$ = new Observable((observer) => {
      const script = document.createElement('script');
      script.id = scriptId;
      script.src = scriptSrc;

      if (document.getElementById(scriptId)) {
        document.getElementById(scriptId).parentNode.removeChild(document.getElementById(scriptId));
        document
          .getElementsByTagName('script')[0]
          .parentNode.insertBefore(script, document.getElementsByTagName('script')[0]);
      } else {
        document
          .getElementsByTagName('script')[0]
          .parentNode.insertBefore(script, document.getElementsByTagName('script')[0]);
      }

      script.onload = (f) => {
        observer.next(f);
      };
    });

    return onload$.pipe(
      share({
        connector: () => new ReplaySubject(1),
        resetOnError: false,
        resetOnComplete: false,
        resetOnRefCountZero: false,
      })
    );
  }
}
